import { Auth } from 'aws-amplify'
import { apiFetch } from './api'
import { apis } from '@/config/apiConfig'
// Action Handlers
import { defaultUser } from '@/actions'

import * as utils from './util'

const DEFAULT_LATITUDE = 39.742043
const DEFAULT_LONGITUDE = -104.991531
const DEFAULT_ZOOM = 5

export async function createLog(user) {
  const response = await fetch('https://geolocation-db.com/json/')
  if (!response.ok) throw new Error('Failed to retrieve geolocation data')
  const data = await response.json()

  const url = apis.apiDatabase.uri + 'logs'
  const method = 'POST'
  const bodyParams = {
    latitude: data.longitude,
    longitude: data.latitude,
    state: data.state,
    userID: user.UUID,
    city: data.city,
    ip: data.IPv4,
  }

  if (user.mapID) bodyParams.mapID = user.mapID

  await apiFetch(url, method, bodyParams, result => {
    console.log('Log created successfully')
  })
}

// USER LOGIN
export const loginInitialize = () =>
  // eslint-disable-next-line no-async-promise-executor, consistent-return
  new Promise(async (resolve, reject) => {
    const user = defaultUser()
    const url = apis.apiDatabase.uri + 'user/init'
    const method = 'GET'

    // Don't set isLoggedIn until we have successful response
    apiFetch(url, method, null, result => {
      if (utils.verifyResult(result)) {
        if (
          typeof result.data !== 'undefined' &&
          typeof result.data.profile !== 'undefined'
        ) {
          const {
            profile,
            isAdmin,
            isActive,
            role,
            permissions,
            adminAccounts,
            accounts,
            preferences,
            accountID,
          } = result.data

          user.UUID = result.userUUID
          user.isAdmin = isAdmin
          user.isActive = isActive
          user.role = role
          user.permissions = permissions
          user.adminAccounts = adminAccounts
          user.profile = { ...user.profile, ...profile }
          user.accounts = accounts
          user.preferences = preferences

          let account
          if (accountID !== null) {
            user.accountID = accountID
            account = utils.objectKeyVal(user.accountID, user.accounts, 'id')

            if (!account || (Array.isArray(account) && !account.length)) {
              user.accountID = accounts.length > 0 ? accounts[0].id : null
              account = utils.objectKeyVal(user.accountID, user.accounts, 'id')
            }
          } else {
            user.accountID =
              accountID == null
                ? accounts.length > 0
                  ? accounts[0].id
                  : null
                : accountID

            account = utils.objectKeyVal(user.accountID, user.accounts, 'id')

            if (!accounts.length) {
              return reject(
                Error(
                  'You are not a part of any accounts. Please contact support@myassetmap.com.'
                )
              )
            }

            user.isAdmin = result.data.adminAccounts.includes(user.accountID)
            user.isActive = !result.data.disabledAccounts.includes(
              user.accountID
            )
            user.role = account.role
            user.permissions = account.permissions
          }

          if (!account || (Array.isArray(account) && !account.length)) {
            return reject(
              Error(
                'No active accounts have been found. Please have your admin add to you an account. If you need additional support, please contact support@myassetmap.com.'
              )
            )
          }

          user.mapID =
            result.data.mapID == null
              ? result.data.accounts.length > 0
                ? typeof account === 'object'
                  ? account.maps && account.maps.length > 0
                    ? account.maps[0].id
                    : null
                  : null
                : null
              : result.data.mapID

          // Only set isLoggedIn if we have all required data
          if (user.UUID && user.accountID && user.mapID) {
            user.isLoggedIn = true
          } else {
            return reject(
              Error(
                'Missing required user data. Please contact support@myassetmap.com.'
              )
            )
          }
        }
      } else {
        return reject(
          Error(
            result.message ??
              'There was an error loading your profile. Refresh the page and contact support@myassetmap.com if the problem persists.'
          )
        )
      }
      console.log('init user ', user)
      // Fire and forget - don't block user initialization
      createLog(user)
      return resolve(user)
    })
  })

export async function createCredentials() {
  try {
    const session = await Auth.currentSession()
    const credentials = await Auth.currentCredentials()
    const essential = await Auth.essentialCredentials(credentials)
    localStorage.setItem('accessKeyId', essential.accessKeyId)
    localStorage.setItem('secretAccessKey', essential.secretAccessKey)
    localStorage.setItem('sessionToken', essential.sessionToken)
    localStorage.setItem('token', session.idToken.jwtToken)
    return essential
  } catch (error) {
    if (!String(error?.message ?? error).includes('No current user')) {
      console.error('Credentials error:', error)
    }
    throw error
  }
}

export const getMapHomeLocation = user => {
  const accountId = user?.accountID
  const mapId = user?.mapID
  const activeAccount = user?.accounts?.filter(
    account => account.id === accountId
  )
  const location = activeAccount[0].maps
    .filter(map => map.id === mapId)
    .map(map => map.location)
  if (!location[0]) {
    location[0] = {}
    location[0].x = DEFAULT_LATITUDE
    location[0].y = DEFAULT_LONGITUDE
    location[0].z = DEFAULT_ZOOM
  }
  return location[0]
}

export const getActiveMap = user => {
  const accountId = user?.accountID
  const mapId = user?.mapID
  const activeAccount = user?.accounts?.filter(
    account => account.id === accountId
  )
  const activeMap = activeAccount[0]?.maps?.filter(map => map.id === mapId)

  return activeMap[0]
}
